import useSWR from 'swr';
import { useContext } from 'react';
import { ScoringContext } from '@/contexts/scoring/context';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { HTTP_STATUS_CODE } from '../constants';
import { ScorerInfoConfig } from '../types';
import { ApiError } from '../ApiError';

export const useScorerInfoConfig = () => {
  const token = useAuthToken();

  const {
    state: { fixtureId, fixtureSummary },
  } = useContext(ScoringContext);

  const { data, error } = useSWR<ScorerInfoConfig[], ApiError>(
    token && fixtureId && fixtureSummary?.collectionId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Fixture(
            fixtureId,
            fixtureSummary.collectionId,
          ).fixtureCollectorsData.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    scorerConfig: data,
    error,
    isLoading: !data && !error,
  };
};
